import {configureStore} from '@reduxjs/toolkit'
import coreReducer from './store-core'

export const store = configureStore({
    reducer: {
        core: coreReducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        thunk: true,
        immutableCheck: false,
        serializableCheck: false
    })
})

export type StoreState = ReturnType<typeof store.getState>;
export type StoreDispatch = typeof store.dispatch;